import React, { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { change } from 'redux-form';
import { Container, EmitPersonalInformationForm, PaymentForm } from '../components/';
import { navigate, showErrorYes } from '../store/Commons';
import { IEmitForm, submitEmitForm } from '../store/Emit';
import { IPlan } from '../store/Quote';

interface IProposalProps {
  changePaymentMethod: (method: string) => void;
  resetChargePercetage: () => void;
  emit: (payload: IEmitForm) => void;
  back: () => void;
  backToStart: () => void;
  fullName: string;
  initialValues: any;
  charges: string;
  planSelected: IPlan;
  emitting: boolean;
  modal: () => void;
  documentId: string;
}

export function Emit(props: IProposalProps) {
  const {
    back,
    backToStart,
    changePaymentMethod,
    emit,
    fullName,
    documentId,
    planSelected,
    emitting,
  } = props;
  const [page, setPage] = useState(1);

  useEffect(() => window.scrollTo(0, 0), [page]);

  const nextPage = () => setPage(page + 1);

  const previousPage = () => setPage(page - 1);

  if (!planSelected.plan_id) {
    backToStart();
  }

  return (
    <Container>
      <div className="container mb50 subscription">
        <div className="row">
          <div className="col-12">
            {!emitting && (
              <>
                <h1 className="text-center mb5 px-37 mb10 mt60">
                  {page === 1 ? (
                    <>
                      Seguro de Accidentes Personales
                    </>
                  ) : (
                    <>
                      Pagar con Falabella Soriana
                    </>
                  )}
                </h1>
                <h2 className="text-center text-primary mb50 px-22">
                  {page === 1 ? (
                    <>
                      Protégete en caso de accidente o enfermedad
                    </>
                  ) : (
                    <>
                      Antes de contratar recuerda revisar si tienes crédito disponible en tu tarjeta.
                    </>
                  )}
                </h2>
              </>
            )}
            <div className="row mt50">
              {page === 1 && (
                <EmitPersonalInformationForm
                  onSubmit={nextPage}
                  previousPage={back}
                />
              )}
              {page === 2 && (
                <PaymentForm
                  changePaymentMethod={changePaymentMethod}
                  documentId={documentId}
                  fullName={fullName}
                  onSubmit={emit}
                  plan={planSelected}
                  previousPage={previousPage}
                  emitting={emitting}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {(!emitting && page === 2) && (
        <div className="container-fluid bg-light-gray pt30 pb30">
          <div className="container">
            <div className="row">
              <div className="col-12 px-14">
                <p>En caso de controversia, usted podrá hacer valer sus derechos ante la Unidad Especializada de Atención de Consultas y Reclamaciones de Chubb Seguros México, S.A. (UNE), al correo electrónico uneseguros@chubb.com</p>
                <p className="mb0">En caso de que tu queja o consulta no haya sido atendida también podrás referirte a la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros (CONDUSEF) al 55 5340 0999 a nivel nacional o por correo a: asesoria@condusef.gob.mx</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </Container>
  );
}

export const mapStateToProps = (state: any) => {
  const {
    Quote: {
      planSelected,
    },
    Emit: { emitting },
    form,
  } = state;

  const formValues =
    (form.proposal && form.proposal.values && form.proposal.values) || {};
  const fullName = `${formValues.name || ''} ${formValues.paternal || ''}`;
  const documentId = `${formValues.documentId || ''}`;

  return {
    documentId,
    emitting,
    fullName,
    initialValues: {
      charges: 1,
      declarationCard: true,
      paymentMethod: 'CMR',
    },
    planSelected,
  };
};

export const mapDispatchToProps = (dispatch: Dispatch) => ({
  back: () => dispatch(navigate('/')),
  backToStart: () => dispatch(navigate('/')),
  changePaymentMethod: (method: string) =>
    dispatch(change('proposal', 'paymentMethod', method)),
  comercialCheck: 'false',
  emit: (payload: IEmitForm) => dispatch(submitEmitForm(payload)),
  modal: () => {
    dispatch(showErrorYes());
    if (process.env.REACT_APP_ENVIRONMENT === 'production') {
      const tagManagerArgs = {
        dataLayer: {
          event: 'vpvModalDPS',
        },
        dataLayerName: 'datalayer',
      };

      TagManager.dataLayer(tagManagerArgs);
    }
  },
  personalDataCheck: 'false',
  resetChargePercetage: () =>
    dispatch(change('proposal', 'charge-percetage-0', '100')),
});

export default connect(mapStateToProps, mapDispatchToProps)(Emit);
